import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Pagination,Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { motion } from "framer-motion";
import "./style.css";

function SwiperComponent({description = false,process=[],heading='Blending technical precision with agile execution to deliver solutions that work.',text,altText}) {
 
 return (
  <div className="space-y-14 ">


<div className="space-y-5 md:w-11/12 lg:w-10/12 xl:w-8/12  text-center mx-auto ">
    <motion.h2
     className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px]  text-center font-bold text-dark font-butler"
      initial={{ opacity: 0, y: 40 }}          
      whileInView={{ opacity: 1, y: 0 }}       
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.3 }}    
    >
    {heading}
    </motion.h2>
{
  text && <p className="text-base md:text-lg text-dark">
{text}
  </p>
}
    
</div>
    <Swiper
      effect={"coverflow"}
      grabCursor={true}
      centeredSlides={true}
      slidesPerView={"auto"}
      initialSlide={2}
      autoplay={{
        delay: 3000,  
        disableOnInteraction: false,  
      }}
      coverflowEffect={{
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2.5,
        slideShadows: true,
      }}
      // pagination={{ clickable: true }}
      navigation={true}
      modules={[EffectCoverflow, Pagination, Navigation,Autoplay]}
      className="mySwiper1"
    >
  
      {process.map((element, index) => (
        <SwiperSlide key={index} className="a">
          {/* <div className=" h-[28rem] md:h-[30rem] w-full relative overflow-hidden shadow-lg rounded-lg "> */}
          <div className=" h-[25rem] md:h-[20rem] w-full relative overflow-hidden shadow-lg rounded-lg ">
            <img
            loading="lazy"
              src={element.image}
              alt={element.altText ? element.altText : element.title}
              className="w-full h-full object-cover object-center"
            />
            <div  className="absolute left-0 top-[0] right-0 px-2 md:px-8  space-y-2  bg-gradient-to-br from-[rgba(109,19,73,0.6)] to-[rgba(223,115,255,0.6)]
 h-full flex  items-center  justify-start "
            >
              <div className=" flex flex-row justify-center  items-center space-x-2 font-bold text-white  px-4 md:px-2 ">
                <div className="flex flex-col md:flex-row  md:space-x-5">

                <span className="text-2xl md:text-3xl  lg:text-3xl">  0{index + 1} </span>
<div className="space-y-2">

                {/* <h3 className="capitalize text-3xl md:text-4xl  lg:text-5xl"> {element.title}</h3> */}
                <h3 className="capitalize text-2xl md:text-3xl  lg:text-3xl"> {element.title}</h3>
           
                {/* <p className="text-lg md:text-xl text-white font-semibold"> */}
                <p className="text-base leading-[1.625rem] text-white font-semibold">
                {element.description}
                </p>
                </div>
</div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
  );
}

export default SwiperComponent;
